import { planCatalog, type PlanId } from "@ebook/contracts";

export type Plan = {
  id: PlanId;
  name: string;
  tagline: string;
  priceLabel: string;
  books: number | null;
  pagesPerBook: number | null;
  highlight?: boolean;
  premium?: boolean;
};

export const plans: Plan[] = [
  {
    id: "free",
    name: "Free",
    tagline: "เริ่มต้นทดลองใช้งานฟรี",
    priceLabel: "ฟรี",
    ...planCatalog.free,
  },
  {
    id: "starter",
    name: "Starter",
    tagline: "สำหรับผู้เริ่มสร้างสื่อออนไลน์",
    priceLabel: "฿99/เดือน",
    ...planCatalog.starter,
  },
  {
    id: "pro",
    name: "Pro",
    tagline: "สำหรับมืออาชีพที่ต้องการผลงานคุณภาพ",
    priceLabel: "฿299/เดือน",
    ...planCatalog.pro,
    highlight: true,
  },
  {
    id: "business",
    name: "Business",
    tagline: "สำหรับทีมและองค์กรที่กำลังเติบโต",
    priceLabel: "฿990/เดือน",
    ...planCatalog.business,
  },
  {
    id: "enterprise",
    name: "Enterprise",
    tagline: "สำหรับองค์กรขนาดใหญ่ที่ต้องการความยืดหยุ่นสูงสุด",
    priceLabel: "เริ่มต้น ฿5,900/เดือน",
    ...planCatalog.enterprise,
    premium: true,
  },
];

export function planById(id: PlanId | null | undefined): Plan | undefined {
  return plans.find((plan) => plan.id === id);
}
